import { Mode, tokens, fonts } from "./theme";
import { useLanguage } from "@/contexts/LanguageContext";

interface Props { mode?: Mode }

const PathMockup = ({ mode = "dark" }: Props) => {
  const T = tokens(mode);
  const isDark = mode === "dark";
  const { t } = useLanguage();

  const chapters = [
    { n: "01", titleKey: "mock.path.c1.title", subKey: "mock.path.c1.sub", lessonsCount: 6, xp: "+480 XP", state: "done" },
    { n: "02", titleKey: "mock.path.c2.title", subKey: "mock.path.c2.sub", lessonsCount: 7, xp: "+560 XP", state: "done" },
    { n: "03", titleKey: "mock.path.c3.title", subKey: "mock.path.c3.sub", lessonsCount: 8, xp: "+640 XP", state: "active", progress: 0.6 },
    { n: "04", titleKey: "mock.path.c4.title", subKey: "mock.path.c4.sub", lessonsCount: 5, xp: "+400 XP", state: "locked" },
  ];

  return (
    <div style={{ background: isDark ? `linear-gradient(170deg, ${T.surface} 0%, ${T.bg} 100%)` : T.surface, color: T.text, fontFamily: fonts.ui, height: "100%", padding: "56px 20px 28px", overflow: "hidden" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
        <div style={{ fontSize: 9, color: T.textDim, letterSpacing: 1.5, textTransform: "uppercase", fontWeight: 600 }}>{t("mock.path.topbar")}</div>
        <div style={{ fontSize: 11, color: T.accent, fontWeight: 700 }}>◈ 1'247</div>
      </div>

      <h2 style={{ fontFamily: fonts.display, fontSize: 32, fontWeight: 400, letterSpacing: -1, lineHeight: 1.0, margin: "0 0 22px" }}>
        {t("mock.path.headline1")} <em style={{ color: T.accent, fontStyle: "italic" }}>{t("mock.path.headline2")}</em>.
      </h2>

      <div style={{ display: "flex", flexDirection: "column", gap: 0, position: "relative" }}>
        {chapters.map((c, i) => {
          const isActive = c.state === "active";
          const isLocked = c.state === "locked";
          const isDone = c.state === "done";
          const offset = i % 2 === 0 ? 0 : 18;
          return (
            <div key={c.n} style={{ marginLeft: offset, marginRight: 18 - offset, marginBottom: 6 }}>
              <div style={{ background: isActive ? T.accent : T.surface, color: isActive ? T.accentInk : T.text, border: `1px solid ${isActive ? T.accent : T.border}`, borderRadius: 18, padding: "14px 14px", opacity: isLocked ? 0.45 : 1 }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
                  <div style={{ fontFamily: fonts.display, fontSize: 28, fontWeight: 400, fontStyle: "italic", color: isActive ? T.accentInk : T.text, lineHeight: 1 }}>{c.n}</div>
                  {isDone && <span style={{ background: isDark ? "#1E4A32" : "#BFE3CB", color: isDark ? "#7AE582" : "#235C3C", fontSize: 9, fontWeight: 700, letterSpacing: 0.5, padding: "3px 8px", borderRadius: 999 }}>{t("mock.path.done")}</span>}
                  {isActive && <span style={{ background: T.coral, color: "#0E1114", fontSize: 9, fontWeight: 700, letterSpacing: 0.5, padding: "3px 8px", borderRadius: 999 }}>{t("mock.path.active")}</span>}
                </div>
                <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 2 }}>{t(c.titleKey)}</div>
                <div style={{ fontSize: 10, opacity: 0.7, marginBottom: 8 }}>{t(c.subKey)}</div>
                <div style={{ fontSize: 9, opacity: 0.7, display: "flex", gap: 10, fontWeight: 600 }}>
                  <span>{c.lessonsCount} {t("mock.path.lessonsUnit")}</span>
                  <span>·</span>
                  <span>{c.xp}</span>
                  {isActive && c.progress !== undefined && (
                    <>
                      <span>·</span>
                      <span>{Math.round(c.progress * 100)}{t("mock.path.progressSuffix")}</span>
                    </>
                  )}
                </div>
                {isActive && c.progress !== undefined && (
                  <div style={{ height: 3, background: "rgba(0,0,0,0.18)", borderRadius: 999, marginTop: 8, overflow: "hidden" }}>
                    <div style={{ width: `${c.progress * 100}%`, height: "100%", background: "rgba(0,0,0,0.55)" }} />
                  </div>
                )}
              </div>
              {i < chapters.length - 1 && (
                <div style={{ width: 1, height: 14, background: T.border, margin: i % 2 === 0 ? "0 0 0 24px" : "0 24px 0 auto" }} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PathMockup;
